<template>
    <div class="p-0 flex-grow-1 text-dark-50 py-2 py-lg-2 mb-5">
        <div class="py-2">
            <div
                v-for="(book, index) in presentation.author_credentials.previous_published_books"
                :key="'previous-book-' + presentation.submission_id + '-' + index"
                class="d-flex mb-2"
            >
                <span class="mr-4">
                    <span class="svg-icon svg-icon-success">
                        <LibrarySvg />
                    </span>
                </span>
                <div class="">
                    <span class="font-weight-bold d-block text-dark-75">{{
                        book.title
                    }}</span>
                    <span class="d-block">{{ book.publisher }}</span>
                    <span class="d-block">{{ book.year }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LibrarySvg from "@/svg/LibrarySvg.vue";

export default {
    components: { LibrarySvg },

    props: ["presentation"],
};
</script>
